import { HttpInterceptorFn } from '@angular/common/http';

import { useLanguage } from './language.composable';

/**
 * Intercepts calls to `/api` and sets the Accept-Language header to the current language.
 *
 * @param apiSegment - The starting segment of the API URL. Only requests starting with this segment will be intercepted
 */
export const languageInterceptor: (apiSegment: string) => HttpInterceptorFn =
    (apiSegment: string) => (req, next) => {
        if (!req.url.startsWith(apiSegment)) {
            return next(req);
        }

        const language = useLanguage();

        return next(
            req.clone({
                setHeaders: {
                    'Accept-Language': language()
                }
            })
        );
    };
